export const BRAND = "HHB Clothing Co";
export const EMAIL = "hhb_china@yahoo.com";
export const PHONE_DISPLAY = "+86 157 5799 2199";
export const PHONE_TEL = "tel:+8615757992199";
export const WHATSAPP_LINK = "https://wa.me/8615757992199?text=Hi%20HHB%20Clothing%20Co%2C%20I%27d%20like%20a%20production%20quote.";
export const WHATSAPP_QR_TARGET = "https://wa.me/8615757992199";
export const WECHAT_ID = "ihassib98";
export const WECHAT_LINK = "https://u.wechat.com/ENpd4i3E4dDS5ylgod-ZjmQ?s=2";
